import { render, staticRenderFns } from "./AdminMajor.vue?vue&type=template&id=6633bc5e"
import script from "./AdminMajor.vue?vue&type=script&lang=js"
export * from "./AdminMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports